import React, { useEffect } from 'react';
import { useParams, useHistory } from "react-router-dom";
import { saveState } from './../../../providers/localStorage';
import { localStorageName } from './../../../providers/localStorageData';
import AuthProvider from './../../../providers/authProvider';
import RestProvider from 'providers/RestProvider';
import { properties } from './RespuestaClaveData';
import { useDispatch, useSelector } from 'react-redux';
import { insertNewState } from 'redux/slicers/kingdomOV3Slice';
import CryptoJS from "crypto-js";

function RespuestaClave() {
    const { datosUsarioClave } = useParams();
    const history = useHistory();
    const { login } = AuthProvider();
    const { crudOperation, crudOperationsType } = RestProvider();
    const dispatch = useDispatch();
    const infoUsuario = useSelector((state) => state.kingdomOV3.infoUsuario);
    const origenLogin = useSelector((state) => state.kingdomOV3.origenLogin);
    const urlProcedenciaProcedimiento = useSelector((state) => state.kingdomOV3.urlProcedenciaProcedimiento);

    const crearObjetoCredencial = () => ({
        tipoAutenticacion: infoUsuario?.tipoAutenticacion,
        nifUsuario: infoUsuario?.interesadoNif,
        nombre: infoUsuario?.interesadoNombre,
        apellido1: infoUsuario?.interesadoApellido1,
        apellido2: infoUsuario?.interesadoApellido2,
        tipoCredencial: properties.TIPO_CREDENCIAL,
    });

    useEffect(() => {
        let urlRespuesta = '/';
        if (origenLogin.redireccion) {
            urlRespuesta = origenLogin.redireccion === '/SeleccionConvocatoriaPerfil' ? origenLogin.redireccion + urlProcedenciaProcedimiento : origenLogin.redireccion;
        } else if (localStorage.getItem('origenLogin')) {
            urlRespuesta = localStorage.getItem('urlProcedenciaProcedimiento') ? localStorage.getItem('origenLogin') + localStorage.getItem('urlProcedenciaProcedimiento') : localStorage.getItem('origenLogin');
        }
        try {
            let datosUsuarios = datosUsarioClave.replaceAll("-", "+").replaceAll("_", "/");

            const encryptedBase64Key = "MjIyMjQ0NDQ2NjY2ODg4OA==";
            const parsedBase64Key = CryptoJS.enc.Base64.parse(encryptedBase64Key);

            const datosDesencriptado = CryptoJS.AES.decrypt(datosUsuarios, parsedBase64Key, {
                mode: CryptoJS.mode.ECB,
                padding: CryptoJS.pad.Pkcs7
            });

            const decryptedText = datosDesencriptado.toString(CryptoJS.enc.Utf8);

            if (decryptedText.startsWith("ERROR:")) {
                const [, mensaje] = decryptedText.split("ERROR:");
                saveState(localStorageName.errorClave, `{"errorClave":{"mensaje":"${mensaje}"}}`, false);
                history.push(urlRespuesta);
            } else {
                const objeto = decryptedText.split("~#");
                const usuarioClave = {
                    interesadoNif: objeto[0],
                    interesadoNombre: objeto[1],
                    interesadoApellido1: objeto[2],
                    interesadoApellido2: objeto[3],
                    tipoAutenticacion: "cl",
                    entidadCif: null,
                    entidadNombre: null
                };
                dispatch(insertNewState({ filnedName: 'infoUsuario', value: usuarioClave }));
                login('ciudadano', '', false);
                history.push(urlRespuesta);
            }
        } catch (error) {
            saveState(localStorageName.errorClave, '{"errorClave":{"mensaje":"Ha ocurrido un error al intentar realizar el login con Cl@ve"}}', false);
            history.push(urlRespuesta);
        }
    }, []);

    useEffect(() => {
        const credencial = crearObjetoCredencial();
        const esValido = credencial.tipoAutenticacion && credencial.tipoCredencial;

        if (esValido) {
            crudOperation(
                crudOperationsType.CUSTOM,
                properties.RESOURCE_VALIDACION,
                { url: properties.REGISTRAR_CREDENCIAL, method: 'post', data: credencial }
            ).catch(() => { });
        }
    }, [infoUsuario]);

    return <div />;
}

export default RespuestaClave;
